module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Legendary Locals of Huntsville Alabama")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-no",
    attrs: {
      "id": "C1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("CHAPTER ONE")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("The Land")]), _vm._v(" "), _c('p', {
    staticClass: "title-head1"
  }, [_vm._v("Founding and Flourishing")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("At the beginning, what is now Madison County was the subject of rivalry between the Chickasaw and Cherokee tribes. The federal government eventually became involved, forcing the Indians to relinquish their rights to “The Great Bend” of the Tennessee River. Anglo settlers began to arrive, among them John Hunt, who had previously settled lands to the north in Tennessee, and who built his home near the Big Spring.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the years that followed, those first settlers farmed cotton, connecting Huntsville to the rest of the nation by utilizing the Tennessee Valley waterways. Wealthy planters and speculators on the cotton economy built sprawling mansions in Huntsville. Architects like George Steele began to make statements on the architectural terrain of the town while simultaneously employing individuals in construction and supporting local businesses in pursuit of supplies. Statesmen from other parts of the country, such as Clement Comer Clay and William Wyatt Bibb, began to move to Huntsville and go about the work of establishing a government. Alabama was entered into the Union in 1819.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The infrastructure flourished—Dr. Thomas Fearn and his brother developed the Huntsville Water Works, using hydraulics to provide water to the city. Additionally, they built the Indian Creek Canal, the first canal in Alabama, to transport cotton from Huntsville to the Tennessee River. Rev. A.B. Jones and the Methodist Episcopal Church founded the Huntsville Female College. William Hooper Councill founded Alabama A&M University.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the Civil War, Huntsville became a target for Union troops, who sought to seize the depot, home to the Memphis & Charleston Railroad—a lifeline for the Confederacy. Union troops successfully occupied Huntsville by the summer of 1863, though many did not make it through the winter. Mary Jane Chadick chronicled the experience in her diaries until the war ended in 1865.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the war, artists such as Howard Weeden began to bring national attention to Huntsville. Jersey cow Lily Flagg won records for yearly butter production. United Charities opened the Huntsville Infirmary in 1895. Entrepreneurs like Robert and Daniel Harrison and Isaac Schiffman opened businesses on the square, and Dunnavant’s Department Store opened downtown. The city finally had its own newspaper, the "), _c('i', [_vm._v("Huntsville Daily Times")]), _vm._v(".")])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Students of the Huntsville Female Seminary")])]), _c('br'), _vm._v("The Huntsville Female Seminary opened in 1831, replacing the Huntsville Female Academy. Architect George Steele designed a facade for it in the mid-1850s. The seminary closed in 1862, and the building was used as a smallpox hospital during the Civil War. (Courtesy of the Huntsville–Madison County Public Library.)")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("John Hunt’s Cabin")])]), _c('br'), _vm._v("John Hunt, an experienced explorer and pioneer, had settled lands in Tennessee prior to finding himself in present-day Huntsville. Hunt built his house under a bluff in 1805 near what is now known as Big Spring. He asserted his rights to the land through squatters’ rights and lived there until 1809, but lost the land because he had not paid the registration fee for it. By that time, the settlement was the obvious and ideal choice for the county seat. The town was incorporated two years later, on November 25, 1811. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    staticClass: "img-90",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Leroy Pope")])]), _c('br'), _vm._v("A wealthy planter from Petersburg, Georgia, Leroy Pope (1764–1845) is known as “the Father of Huntsville.” In 1810, he purchased 160 acres of land settled by John Hunt for $23.50 per acre; it was on this land that the plan for Huntsville was eventually laid. Pope suggested the settlement be called Twickenham, after Alexander Pope’s English home. Leroy Pope later handed over his land to the city, which was incorporated in 1811 as Huntsville.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope built his own home in 1825 on a bluff known as Echols Hill. He marveled that he could look out from his mansion to see the temporary capital of the state and thriving town he had helped create. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F4.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("George Gilliam Steele")])]), _c('br'), _vm._v("Because of bricks stamped with his name, it is clear that land speculator George Steele (1798–1855) was in Huntsville by 1822 at the latest, and likely as early as 1818. The Virginia native married Eliza Ann Weaver in 1823 and bought 10 acres of land from Leroy Pope in 1824, in an area roughly bordered by Clinton, Randolph, Lincoln, and Calhoun Streets in downtown.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With the labor of his 74 slaves, many of whom were skilled bricklayers, masons, and stonecutters, Steele explored and executed his passion for architecture. Steele attended architectural lectures in New York City and most likely learned the art of architecture as an apprentice. He resorted often to the use of builder’s pattern books and embraced the Federal style just as it was falling out of favor in other parts of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Steele later turned to the Classical Revival style, evident in his work as the leading architect of the second Madison County Courthouse (1836, pictured above right) and in his design of the State Bank of Alabama (1835) on the west side of the square. Both buildings have a signature temple form, as does his remodel of Dr. Thomas Fearn’s home on Franklin Street in downtown Huntsville. Steele’s elegant and simple style permeated other landmarks as well, including the Huntsville Female College (early 1850s), the Huntsville Female Seminary (1831), the Cumberland Presbyterian Church (1845), and the Leroy Pope mansion (1815). Of these structures, only the Pope mansion still stands today.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Steele employed many local bricklayers, painters, masons, and carpenters, and turned to local businesses for supplies, providing numerous local jobs. Steele Street, named after him, remains one of the most architecturally interesting streets in Huntsville, a perfect microcosm of architectural design and preservation in stunning tribute to its namesake. (Both, courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F5.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Thomas Bibb")])]), _c('br'), _vm._v("Born in Virginia, Bibb (1784–1839) served on the Committee of 15 as one of the 44 delegates to the Alabama Constitutional Convention held in Huntsville, which drafted the details for the first constitution of the state. As part of the Florence-Cypress Land Company, he and four other trustees joined in 1818 to establish the town of Triana, the second town incorporated in Madison County. Called by James Record “a dream come true,” Triana was located at the mouth of Indian Creek, situated perfectly to transfer large quantities of cotton and other goods from the Tennessee River to the rest of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Along with 450 others, many of whom, like Bibb, lived in other places, he signed the Simms Settlement petition to request the US government not remove Anglo Americans from parcels they had settled on Chickasaw Indian land in what is present-day Giles County, Tennessee. Bibb built Belle Manor (presently known as Belle Mina) in Limestone County. A replica of the Georgian-style plantation can be seen on Williams Avenue in downtown Huntsville. Bibb was president of the Alabama state senate as well as the second governor of the state, a position he assumed following the death of his brother, William Wyatt Bibb.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Though Thomas Bibb died in New Orleans, he was reinterred 20 years after his death at Maple Hill Cemetery, where four other Alabama governors are buried. It is rumored that Bibb’s body was preserved in a barrel of whiskey to transport him to his final resting place. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("William Wyatt Bibb")])]), _c('br'), _vm._v("The eldest of eight children, William Bibb (1781–1820) studied at William and Mary College prior to receiving a medical degree from the University of Pennsylvania. He then moved to Georgia, where he served in the state senate. In 1817, he was appointed governor of the territory of Alabama and, in 1819, worked tirelessly to secure Cahaba as its capital. Bibb also worked to set up the fundamental aspects of the government of this new state, which entered the Union in 1819. Bibb was married to Mary Freeman.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although he suffered from tuberculosis and other ailments, Bibb died not because of his poor health, but from injuries sustained after being thrown from a horse that had been surprised by a clap of thunder during a storm. Bibb’s brother Thomas finished his term as governor. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F7.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Clement Comer Clay")])]), _c('br'), _vm._v("Born in Halifax County, Virginia, Clement Clay spent his childhood in Tennessee, received his law degree from East Tennessee College, and moved to Huntsville in 1811 after being admitted to the bar in 1809. He chaired the Committee of 15, representing Madison County at the Constitutional Convention in 1819.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clay (1789–1866) had a robust political career, serving on the state supreme court from 1820 to 1823 as its first chief justice. Described by some as the most popular statesman of the period, he continued his political career as a member of the Alabama legislature (1827), a member of the US Congress (1829), as the eighth governor of Alabama (1835), and a member of the US Senate (1837). His only break from politics was self-imposed and came between 1823 and 1827, following a duel in which he allegedly shot his opponent in the leg.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clay spent a fair amount of his political career handling the Creek Indian War of 1836, a fracas between the Indians and white settlers over land. His office eventually was the site for one of Huntsville’s post offices and, later, of the US State Surveyors Office, which mapped vast areas of Indian territory in North Alabama prior to their sale by the federal government.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clay’s son John Withers Clay was the editor of "), _c('i', [_vm._v("The Huntsville Democrat")]), _vm._v(" and lived in a home on Eustis Avenue originally built for the steward of the Huntsville Female Seminary (above right). Clay is one of five Alabama governors buried in Maple Hill Cemetery. (Both, courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F8.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Thomas Fearn")])]), _c('br'), _vm._v("Graduate of the Royal College of Surgeons and of St. Thomas’ in Paris, and with honorary degrees from Rutgers and Transylvania Universities, Dr. Thomas Fearn (1789–1863) acquired a wonderful reputation as a doctor and as a public servant in his community.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dr. Fearn experimented successfully with the medicinal use of quinine, making it from the bark of a tree and using it to reduce fever caused by typhoid. He is sometimes credited with the naming of Monte Sano, following his construction of a cabin on the mountain for the purpose of housing an ill child.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition to his numerous achievements as a medical doctor, Dr. Fearn served the public in many other ways, including as an active member of the First Presbyterian Church, a part of the Committee of Vigilance, part of the first Confederate Congress, and a leader in the abolitionist movement.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1835, he and his brother George spent $2,530.30 to acquire Huntsville Water Works and went on to build Alabama’s first, and the nation’s second, waterworks system, supplying the town of Huntsville with water from the Big Spring by way of hydraulic machinery. Along with Leroy Pope, Fearn was one of the commissioners assigned to incorporate the Indian Creek Navigation Company, which headed the Indian Creek Canal project. This first canal in Alabama, the Indian Creek Canal (now the Big Spring), was begun in 1820 and completed in 1831, due in large part to the efforts of Fearn, who was known as the president and leading spirit of the canal enterprise; Fearn’s Canal, as it came to be called, was declared the first navigable canal in the western country in 1827.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the canal opened, the Fearns began opening sawmills and gristmills on their newly acquired timberlands and announced in 1835 that they were starting the Huntsville Canal Company. By that point, however, there was little public interest in non-mechanized timber production, and the company did not move forward successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fearn served three terms in the Alabama House of Representatives, served on the board of planters and on the board of Merchants Bank, and collaborated with Clement Comer Clay, eighth governor of Alabama, to promote a railroad connecting Memphis, Tuscumbia, Huntsville, and Rome, Georgia. He and his brother helped develop Viduta, incorporated in 1833 on Monte Sano Mountain. Dr. Fearn was the father of seven daughters and was predeceased by his wife by 21 years. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F9.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("A.B. Jones")])]), _c('br'), _vm._v("In 1851, Rev. A.B. Jones (d. 1924) and the Methodist Episcopal Church organized and founded the Huntsville Female College. Housed on Randolph Street in a building designed by George Steele, the college was a premier institution of female education for students in the primary grades through college level. It offered a wide variety of courses, including English, Latin, German, music, drawing, and painting. Huntsville Female College’s goal was to “secure the symmetrical development of body, mind, and soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The college was destroyed by fire in January 1895. Jones relocated to Gadsden, Alabama, to open another institution of learning, Jones College for Young Ladies, which he opened in the former Bellevue Hotel. Below, former students of Huntsville Female College gather for a reunion. (Both, courtesy of the Huntsville–Madison County Public Library Archives.)")])]), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F10.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F11.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Virginia Tunstall Clay-Clopton")])]), _c('br'), _vm._v("Known to many as the “Belle of Washington,” Virginia Clay Clopton (1825–1915) spent the first part of her life a bit less glamorously than the place to which her socialite status eventually took her. Born in Nash County, North Carolina, she passed much of her childhood in Tuscaloosa, Alabama, and her years as a young lady in Nashville, Tennessee. She graduated from the Nashville Female Academy in 1840 and married Clement Claiborne Clay shortly thereafter and moved to Huntsville. When Clay was elected to the US Senate in 1853, the Clays moved to Washington, where Virginia hobnobbed with a number of socialites, including Jefferson and Varina Davis.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Upon Alabama’s secession from the Union in 1861, Clay resigned his Senate seat to join the Confederate legislature. Accordingly, Virginia moved her socializing to Richmond, Virginia, remaining close friends with Varina Davis—a friendship that proved a good support system in 1865, when both women’s husbands were arrested for conspiracy to assassinate President Lincoln. In spite of Virginia’s numerous letters and written appeals to beg for the release of her husband, Clay remained a prisoner in Fort Monroe, Virginia, until he was released by President Johnson in 1866 and returned to Huntsville. After Clay’s death 16 years later, Virginia eventually remarried.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Following the death of her second husband, Virginia wrote an account of her years in Washington as a socialite and southern belle, with particular attention to the details surrounding the South’s evacuation from Washington following Alabama’s secession from the Union. Her book, "), _c('i', [_vm._v("A Belle of the Fifties: Memoirs of Mrs. Clay, of Alabama, Covering Social and Political Life in Washington and the South 1853–1866")]), _vm._v(", offers a picaresque, poetic, and erudite account of Virginia’s life, beginning with her girlhood in Tuscaloosa and continuing through her first husband’s release from Fort Monroe. Doubleday published the book in 1904, by which point Virginia had become actively involved in the suffragist movement, a cause for which she fought until her death in 1915. Pictured above are Huntsville suffragettes. (Both, courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F12.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Sally Carter")])]), _c('br'), _vm._v("Just three weeks shy of her 16th birthday, Sally Carter (1821–1837) was visiting her sister at the Cedarhurst plantation in Huntsville when she fell ill and died; she had been staying on the second floor of the home. Many years later, a boy from South Alabama was visiting the home, sleeping on a cot outside of Carter’s former bedroom. He had a dream about her one night during a thunderstorm in which Carter informed him that her tombstone, just outside the home, had been toppled by the storm. When he went out the next morning to check, the stone had indeed fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Carter’s grave on the Cedarhurst site was visited by many people curious about her fate and subsequent lingering presence, and unfortunately, by vandals as well. When the land was developed into a gated community in the early 1980s, her grave was moved to Maple Hill Cemetery, though her bedroom remained preserved in the home, which is now the community’s clubhouse. Residents still report strange happenings around the room—doors opening and closing, and sometimes, the sound of a girl’s laughter. In this photograph, Leslie Kilgore portrays Sally Carter at her grave during the 2013 Cemetery Stroll sponsored by the Huntsville Pilgrimage Association. (Photograph by the author.)")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Mary Jane Chadick")])]), _c('br'), _vm._v("The wife of a Presbyterian minister, Mary Jane Chadick (c. 1820–1867) kept a diary and detailed account of the Union occupation of Huntsville during the Civil War between 1862 and 1865. Chadick recorded the Union’s successful and quick takeover of the depot, Huntsville’s lifeline to such cities as Charleston and Memphis. Chadick recorded such details as Huntsville’s brief reprieve from Union occupancy between 1862 and the summer of 1863, when 5,000 Federal troops occupied the city; and the winter of 1864, when harsh conditions, in combination with a smallpox outbreak and an explosion at the depot, killed off many of the troops. Chadick ceased her recordings shortly after Robert E. Lee’s surrender in April 1865. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Bartley Harris")])]), _c('br'), _vm._v("In 1820, William Harris established the African Baptist Church, the oldest Primitive Baptist church in the state of Alabama. Because slaves did not have property rights, the congregation met in the Old Georgia Graveyard, a slave cemetery near the intersection of Governors Drive and Madison Street, where Huntsville Hospital is now located. The congregation eventually built a church in the graveyard, which was burned down during the Union occupation of Huntsville in the Civil War. In 1972, Ulysses S. Grant granted money to rebuild the church in a nearby location, and the church was renamed the Saint Bartley Primitive Baptist Church, after the second pastor of the church, Bartley Harris (pictured). During his time as pastor, Harris baptized over 3,000 people in the Big Spring. He is buried in Maple Hill Cemetery. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F15.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("William Hooper Councill")])]), _c('br'), _vm._v("An ex-slave who arrived in Alabama in 1857, William Councill (1848–1909) helped to establish and found Alabama A&M University. Known then as the Colored Normal School at Huntsville, the school opened in May 1875 with 61 students and two teachers in a rented building on Clinton Street. Councill served as the school’s first president.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Under the directive of a bill in the Alabama state legislature in 1873 to establish “a state normal school and university for the education of the colored teachers and students,” the school, receiving state funding through the land-grant process, was required to defer to the state. A&M’s curriculum, under the direction of Councill, focused on industrial education, and quite successfully so. The school quickly received more state funds and eventually changed its name to the State Normal and Industrial School at Huntsville. The school continued to excel and received more money under the 1890 Morrill Act in order to support programs in engineering and agriculture. It changed its name again to the State Agricultural and Mechanical College for Negroes and moved to a larger campus, its current location in Normal, Alabama, in 1891. By 1948, the school was called Alabama Agricultural and Mechanical College and was fully accredited by the Southern Association of Colleges and Secondary Schools by 1963. By 1969, it became Alabama A&M University, as it is known today. It offers graduate programs and enrolls over 5,300 students. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('img', {
    staticClass: "img-90",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F16.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Leroy Pope Walker")])]), _c('br'), _vm._v("Although Walker’s career was bookended by his law practice, it is perhaps the time in between that allowed him to leave his mark on history. Born in Huntsville, Walker (1817–1884) attended the University of Alabama in Tuscaloosa and went on to get his law degree from the University of Virginia in Charlottesville. He served in the Alabama House of Representatives, including time as speaker. During the 1860 Democratic National Convention, he chaired the Alabama delegation to that convention. A secessionist, Walker was the first Confederate secretary of war and gave the orders to fire on Fort Sumter, the event that officially began the Civil War. During wartime, Walker served as a brigadier general in the Confederate army and as a military court judge. After the war, he resumed his career in law, defending such notables as Frank James, the brother of outlaw Jesse James. He presided as president of the Alabama State Constitutional Convention in 1875. Walker is buried in Maple Hill Cemetery. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F17.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Maria Howard Weeden")])]), _c('br'), _vm._v("Artist and poet Maria Howard Weeden (1846–1905), known eventually as Howard, grew up in Huntsville and attended the Huntsville Female Seminary. Her father died when she was only a baby. Her mother recognized Howard’s artistic talent at a young age and acquired for her private art lessons. The development of this talent proved quite useful in later years, when Howard was able to paint notecards, mementos, and other trinkets to sell, as well as offer her own art classes when the family experienced financial hardship.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the Civil War, Union troops occupied the Weeden family home, and they were forced to vacate to Tuskegee, where Weeden attended the Tuskegee Methodist Female College. While there, she made the acquaintance of George Price, whose daughter Elizabeth became a close friend and advocate of Weeden’s. Elizabeth displayed Weeden’s works in her Nashville music studio and also carried several of her portraits to Germany to display in a gallery there.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Weeden became most known for portraits of the freed people who had come to have such an influence on her life and on her upbringing. Her works appeared in several books in her later years, including "), _c('i', [_vm._v("Shadows on the Wall")]), _vm._v(", published by a small press in Boston. Other books followed, and Weeden began to write her own poems to tell the stories of the people whose images she so expertly and realistically portrayed. One of her paintings is on the opposite page.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Weeden, who wrote many articles for the "), _c('i', [_vm._v("Christian Observer")]), _vm._v(" newspaper under the pseudonym Flake White, died in her home, the same one in which she was born, in April 1862. She is buried in Maple Hill Cemetery. (Above, courtesy of the Huntsville–Madison County Public Library Archives; opposite, courtesy of the Weeden House Museum and Garden.)")])]), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F18.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F19.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Mollie Teal")])]), _c('br'), _vm._v("Teal (1852–1899), a Huntsville businesswoman, was better known as a madam who ran a reportedly quite successful brothel in town. She willed her house and place of business to the city in hopes that it be used for a different kind of community service. In 1904, United Charities relocated an infirmary to the house; this infirmary was part of the official Huntsville Hospital System, which had been established on Mill Street in 1895. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Betty Bernstein Goldsmith")])]), _c('br'), _vm._v("The wife and mother of two influential city leaders, Goldsmith (1859–1928) served as president and first vice president on the board of United Charities, which she helped found in 1895. The organization, which was established to help the sick and needy, opened the Huntsville Infirmary that same year. It moved to several different locations in the city, including to Madam Mollie Teal’s house, and eventually was renamed Huntsville Hospital in 1926. Goldsmith served on its original board of control until her death in 1928. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F21.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Lily Flagg")])]), _c('br'), _vm._v("After Signal’s Lily Flagg of Huntsville won the world record for butter production at the Chicago World’s Fair in 1893, "), _c('i', [_vm._v("The Sydney Mail")]), _vm._v(" of Australia described the Jersey cow as “perhaps not a model cow in appearance . . . [but] of good form and . . . of strong constitution. . . . She possesses that greatest of all thoroughbred gifts, the power of transmitting her good qualities to her offspring, and as she has dropped eight calves . . . the world is likely to be greatly benefited by the good work of Signal’s Lily Flagg.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Previous records for yearly butter production had been set at 484 pounds, 4 ounces by an Oakes cow, and 867 pounds, 14.75 ounces by another Jersey cow. Lily Flagg, who at the time weighed 950 pounds, achieved her record by producing 1,047 pounds and three-fourths of an ounce of butter in one year. Thoroughbred and registered, she was born in 1884 and bred in Kentucky and was only one-twelfth Signal. News of her triumph spread across the country and was widely reported in periodicals, including the "), _c('i', [_vm._v("New York Times")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lily Flagg’s owner, Samuel Moore, was a planter in Huntsville who had inherited his plantation from his wealthy doctor father, who was one of three trustees of the land that Leroy Pope had deeded. Upon his return to Huntsville with his prize-winning cow, Moore threw a grand party for her. He sent formal invitations as far as Chicago, hired an Italian orchestra from Nashville, and served over 50 kinds of cake. He built a 50-foot dance platform, which was backlit by one of the first electrical lighting systems to be used in the southeastern United States. As a final touch, he painted his house butter yellow to commemorate the occasion. The Jersey cow received her long line of guests from her stable, where she stood amid abundant displays of roses.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lily Flagg’s legend continued to live on after her death. There is Lily Flagg Gin, for cotton manufacturing; Lily Flagg Village, a community in South Huntsville that was annexed into the city, whose swim team is called the Lily Flagg Cows; and the locally brewed beer Lily Flagg Milk Stout. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F22.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("William Willis Garth")])]), _c('br'), _vm._v("Born in Morgan County and educated at Emory and Henry College and at the University of Virginia–Charlottesville Law School, Garth (1828–1912) practiced law in Huntsville and served a term in the 45th Congress. During the Civil War, Garth acted as lieutenant colonel on the staff of Gen. James Longstreet, one of the principal generals of the Confederacy. Although Garth had no specific interest in land or railroad speculation, he served as the director of the Memphis & Charleston Railroad, which Gen. Robert E. Lee’s advisors identified as the “vertebrae of the Confederacy.” In 1881, Garth purchased the Drake Farm; that land was sold to the Jones family in 1939. Garth is buried in Maple Hill Cemetery. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Robert Harrison")])]), _c('br'), _vm._v("Robert Harrison (1872–1952) and his brother Daniel founded Harrison Brothers Hardware on the south side of the square in downtown Huntsville in 1897. According to local lore, the last duel in Huntsville was fought in front of Harrison Brothers in 1909 over booze or a lottery. One of the brothers was shot, but not fatally. When Robert passed away in the 1950s, his sons John and Daniel inherited the business and continued to run it as a hardware store until 1983, when John passed away. The Huntsville Historic Foundation purchased the business to preserve its legacy of quality-made products and as a model family business. The store remains true to that intention, selling high-quality local art and handcrafted local pottery, among other fineries. It still offers items the Harrison brothers would have carried, including marbles, gardening tools, and candy. The brothers’ desk, ledgers, stove, safe, and cash register remain in the store. (Photograph by the author.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F24.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Michael O’Shaugnessy")])]), _c('br'), _vm._v("A cottonseed oil tycoon who moved his family from Nashville to Huntsville in 1882, Michael O’Shaugnessy built Kildare (pictured), one of the most elaborate homes in Huntsville. The 40-room, 17,000-square-foot Queen Anne–style home was built on 75 acres of land and featured a variety of elaborate accents, including Hungarian vases, Japanese screens, and parlors trimmed in ebony and gold. When O’Shaugnessy went blind in 1900, his wife sold the home to the trust of Virginia McCormick, daughter of Cyrus McCormick, inventor of the mechanical reaper.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("O’Shaugnessy (1861–1941) and his brother James were businessmen who built the Huntsville Cotton Oil Mill in 1881. The two also formed the North Alabama Improvement Company, which helped fund the construction of Dallas Mill and the Monte Sano Hotel, whose guests included Helen Keller and William Vanderbilt. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Hawkins Davenport Westmoreland")])]), _c('br'), _vm._v("A graduate of Nashville Medical University, Dr. Westmoreland (1873–1925) moved to Huntsville in 1904. He partnered with Dr. Felix Baldridge, and together the two helped to dedicate the operating room at Alabama A&M University. Dr. Westmoreland worked with Dr. Baldridge, who owned one of the first motor vehicles in Huntsville, to deliver babies in the early part of the 20th century. In 1905, Westmoreland became the first president of the Madison County Medical Society. He also served in World War I. He is buried in Athens City Cemetery. (Courtesy of the Huntsville–Madison County Public Library Archives.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F26.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Isaac Schiffman")])]), _c('br'), _vm._v("Schiffman (1856–1910) immigrated to the United States from Hoppstädten, Germany, in 1875 to work with his uncle Solomon Schiffman in his mercantile business in Huntsville. Following his uncle’s death in 1894, Isaac began to buy farmland and eventually changed the name of the company from S. Schiffman & Company to I. Schiffman & Company, the name it still operates under today.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I. Schiffman & Company became involved in the investment and cotton business around the turn of the 20th century. Isaac (left) purchased the Southern Savings & Loan building on the east side of the square to house the company. He died in 1910, and ownership of the company passed to his son Robert and, eventually, to his son-in-law Lawrence B. Goldsmith Sr. Throughout the years, the company’s activities have included a cattle breeding business and a Dodge dealership, and its assets have included many properties: Big Cove Farm, close to where the popular Hampton Cove community is located; Green Cove Farm near the Tennessee River, which the federal government used for the installation of Redstone Arsenal; and numerous properties in downtown Huntsville. Below, Goldsmith Jr. is pictured in the I. Schiffman Building on East Side Square in 1986. (Both, courtesy of the Huntsville–Madison County Public Library Archives.)")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F27.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 84
// module chunks = 0